import { render, staticRenderFns } from "./CommissionsTotalizer.vue?vue&type=template&id=15a99f18&scoped=true"
import script from "./CommissionsTotalizer.vue?vue&type=script&lang=js"
export * from "./CommissionsTotalizer.vue?vue&type=script&lang=js"
import style0 from "./CommissionsTotalizer.vue?vue&type=style&index=0&id=15a99f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a99f18",
  null
  
)

export default component.exports